import { useEffect, useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import { FieldComponent } from 'libs/form';
import { themes } from 'libs/ui';
import { AddButton, Content, InputsPlace, FieldPlace } from './interval-simple-inputs.styled';

const defaultPeriod = { start_at: '00:00:00', amount: '0' };

export const IntervalSimpleInputs = (props) => {
  const { fields, disabled, tableFields } = props;
  const { t } = useTranslation();
  /**
   * add period
   */
  const addPeriod = () => {
    fields.push(defaultPeriod);
  };

  // default vals
  useEffect(() => {
    if (fields.length === 0) {
      addPeriod();
    }
  }, [fields]);

  /**
   * delete period
   * @param {*} index
   */
  const deletePeriod = (index) => {
    fields.remove(index);
  };

  // const validatePeriod = useCallback(min1(t), [t]);

  return (
    <Content>
      {fields.map((field, index) => {
        return (
          <li key={index}>
            <InputsPlace>
              <FieldPlace w={tableFields[0].w} right={tableFields[0].right} $center={tableFields[0].$center}>
                <FieldComponent type="time" name={`${field}.start_at`} disabled={disabled} />
              </FieldPlace>
              <FieldPlace w={tableFields[1].w} right={tableFields[1].right} className="with-border">
                <FieldComponent type="text" name={`${field}.amount`} naturalNumber withMinus fractional maxValueLength={7} disabled={disabled} />
                <span>{t('grid.₽')}</span>
              </FieldPlace>
              {!disabled && fields.length > 1 && <img src="/images/cross_icon_white.png" onClick={() => deletePeriod(index)} alt="" />}
            </InputsPlace>
          </li>
        );
      })}

      {!disabled && (
        <AddButton type="button" theme={themes.blue} disabled={disabled} onClick={addPeriod}>
          <i className="fa fa-plus" />
          {t('buttons.Добавить период')}
        </AddButton>
      )}
    </Content>
  );
};
